/* global dataLayer */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { createTasteProfileEvent } from 'utils/tagManager'
import styles from './choice.css'

const isMobile = () => window.Modernizr && Modernizr.touch // eslint-disable-line no-undef

class Choice extends PureComponent {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.saveAnswer = () => this.props.clickHandler(this.props.choiceObj.id)
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this)
    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleMouseOut = this.handleMouseOut.bind(this)
  }

  componentWillMount () {
    this.setState({
      hover: false
    })
  }

  render () {
    const {choiceObj, selected, style, className, onAnimationEnd, image} = this.props
    const {animate, hover} = this.state
    const {choice} = choiceObj

    // disable hover effects on touch devices
    // and trigger mobile-only animation when button is clicked
    let buttonClassName = selected || hover ? styles.activeButton : styles.button
    buttonClassName = classnames(buttonClassName, {
      [styles.animateButton]: animate
    })
    let buttonProps = {
      onMouseOver: this.handleMouseOver,
      onFocus: this.handleMouseOver,
      onMouseOut: this.handleMouseOut,
      onBlur: this.handleMouseOut
    }
    if (isMobile()) {
      buttonProps = {}
    }
    return (
      <div
        className={classnames(className, styles.wrapper)}
        style={style}
        onAnimationEnd={onAnimationEnd}
      >
        <button
          className={buttonClassName}
          {...buttonProps}
          onClick={this.handleClick}
          onAnimationEnd={this.handleAnimationEnd}
        >

          <div className={styles.imageWrap}>
            <img
              src={image}
              alt={choice}
              className={styles.image}
            />
            <div className={styles.checkmark} />
          </div>

          <div className={styles.answerTextsWrapper}>
            <p className={styles.answerText}>{choice}</p>
          </div>
        </button>
      </div>
    )
  }

  handleClick () {
    dataLayer.push(
      createTasteProfileEvent(
        this.props.eventAction,
        this.props.choiceObj.choice
      )
    )
    if (isMobile()) {
      this.setState({
        animate: true
      })
    } else {
      this.saveAnswer()
    }
  }

  handleAnimationEnd () {
    this.setState({
      animate: false
    })
    this.saveAnswer()
  }

  handleMouseOver () {
    this.setState({
      hover: true
    })
  }

  handleMouseOut () {
    this.setState({
      hover: false
    })
  }
}

Choice.propTypes = {
  choiceObj: PropTypes.shape({
    id: PropTypes.number.isRequired,
    choice: PropTypes.string.isRequired
  }).isRequired,
  selected: PropTypes.bool,
  clickHandler: PropTypes.func.isRequired,
  eventAction: PropTypes.string.isRequired,
  onAnimationEnd: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.shape(),
  questionUrl: PropTypes.string.isRequired,
  image: PropTypes.string
}

Choice.defaultProps = {
  onAnimationEnd: () => {
  },
  selected: false,
  className: null,
  style: {}
}

export default Choice
